import { Api } from "../api";
import { getCookie } from "../core/utils";

const jwt = getCookie("book-d booking token");

export const createBooking = async (data: any) => {
  const response = await Api.post("/booking/service", data, {
    headers: {
      "x-access-token": jwt,
    },
  });

  return response.data;
};

export const getTeamMembers = async (business_id: string) => {
  const response = await Api.post(
    "/team-member/list",
    { business_id },
    {
      headers: {
        "x-access-token": jwt,
      },
    },
  );

  return response.data?.data;
};

export const getBookingStatus = async (bookingId: string) => {
  const response = await Api.get(`/booking/status/${bookingId}`, {});

  return response.data;
};

export const confirmBooking = async (bookingId: string) => {
  const response = await Api.post(
    "/booking/service/availed",
    { booking_details_id: bookingId },
    {},
  );

  return response.data;
};

export const getBookingDetailsByService = async (bookingId: string) => {
  const response = await Api.post(
    "/booking/details/by/service",
    { booking_details_id: bookingId },
    {},
  );

  return response.data;
};

export const getBookingDetailsByMasterId = async (bookingMasterId: string) => {
  const response = await Api.get(`/booking/details/${bookingMasterId}`, {});

  return response.data;
};

export const raiseDispute = async (bookingId: string, message: string) => {
  const response = await Api.post(
    "/booking/dispute/raise",
    { booking_details_id: bookingId, customer_message: message },
    {},
  );

  return response.data;
};

export const reviewRating = async (formData: FormData) => {
  const response = await Api.post("/review-rating/service", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const fetchDiscountCoupon = async (data: any) => {
  const response = await Api.post("/discount-coupon/fetch", data, {
    headers: {
      "x-access-token": jwt,
    },
  });

  return response.data;
};
